export default {
  invoices: []
}
